export default {
  invoices: []
}
